export interface ChatMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
  isStreaming?: boolean;
}

export interface ChatConnectedEvent {
  messageId: string;
  timestamp: string;
  user: {
    id: string;
    email: string;
  };
}

export interface ChatMessageEvent {
  messageId: string;
  delta: string;
  index: number;
}

export interface ChatCompleteEvent {
  messageId: string;
  totalChunks: number;
}

export interface ChatErrorEvent {
  error: string;
  code?: string;
}

export interface ChatError {
  message: string;
  code?: string;
}

export interface ChatPingEvent {
  messageId: string;
  timestamp: string;
}

export enum ChatEventType {
  Connected = 'connected',
  Message = 'message',
  Ping = 'ping',
  Complete = 'complete',
  Error = 'error',
}

export interface ChatEvent {
  type: ChatEventType;
  data: ChatConnectedEvent | ChatMessageEvent | ChatCompleteEvent | ChatErrorEvent | ChatPingEvent;
}

export interface ChatState {
  messages: ChatMessage[];
  isConnected: boolean;
  isLoading: boolean;
  error: ChatError | null;
  persistenceError: string | null;
  hasReachedLimit: boolean;
}

export interface DailyReport {
  url: string;
  date: string;
  generatedAt: string;
  message: string;
}

export interface DailyReportState {
  report: DailyReport | null;
  isLoading: boolean;
  error: boolean;
  isDismissed: boolean;
}
